import { isValidTime, timeToMinutes } from '@app/shared/components/TimeInput';

import type { FormRule } from 'antd';

const INVALID_TIME_MESSAGE = 'Введите время в формате ЧЧ:ММ';

// Перерыв короче этого не сохраняем (us/11381).
export const MIN_BREAK_DURATION_MINUTES = 10;

export const getTimeStartRules = (): FormRule[] => [
  { required: true, message: 'Введите время начала' },
  {
    validator: (_, value?: string) =>
      !value || isValidTime(value)
        ? Promise.resolve()
        : Promise.reject(new Error(INVALID_TIME_MESSAGE)),
  },
];

// minDurationMinutes — минимальная длина интервала; без него конец
// должен быть просто позже начала.
export const getTimeEndRules = (minDurationMinutes = 0): FormRule[] => [
  { required: true, message: 'Введите время окончания' },
  ({ getFieldValue }) => ({
    validator: (_, value?: string) => {
      if (!value) {
        return Promise.resolve();
      }

      if (!isValidTime(value)) {
        return Promise.reject(new Error(INVALID_TIME_MESSAGE));
      }

      const timeS = getFieldValue('timeS') as string | undefined;

      if (!isValidTime(timeS)) {
        return Promise.resolve();
      }

      const durationMinutes = timeToMinutes(value) - timeToMinutes(timeS);

      if (durationMinutes <= 0) {
        return Promise.reject(
          new Error('Время окончания должно быть позже начала')
        );
      }

      if (durationMinutes < minDurationMinutes) {
        return Promise.reject(
          new Error(`Минимальная длительность — ${minDurationMinutes} мин`)
        );
      }

      return Promise.resolve();
    },
  }),
];

// Интервал, по которому имеет смысл спрашивать бэкенд о конфликтах:
// оба значения введены полностью и интервал проходит правила формы.
export const isCompleteTimeRange = (
  timeS?: string,
  timeE?: string,
  minDurationMinutes = 0
) => {
  if (!isValidTime(timeS) || !isValidTime(timeE)) {
    return false;
  }

  const durationMinutes = timeToMinutes(timeE) - timeToMinutes(timeS);

  return durationMinutes > 0 && durationMinutes >= minDurationMinutes;
};
